import React from 'react'
import Navbar from '../inc/Navbar'
import Slider from '../inc/Slider'
import Doctorbook from "../images/DOCTORS ICON.jpg";
import Labtestbook from "../images/Labtest Book.jpg";
import healthpackage from "../images/Healthpackage.jpg";
import drlalpathlab from "../images/home_banner_first1.webp";
import drlalpathlabpackage from "../images/Routine-Packages.webp";
import radiology from "../images/Radiology.jpg";


import "./Home.css";
import AllDoctor from './AllDoctors';
import Labtest from './Labtest';
import Radiology from './Radiology';
import ScrollToTop from "react-scroll-to-top";


function Home() {
  return (
    <div>
      <Navbar />
      <br />
      <br />
      <br />
      <br />
      <ScrollToTop smooth top="100" color="maroon" />
      <div className="album py-3">
        <div className="container">
               <div className="row">
            <div className="col-md-8 mt-3">
          <Slider />
        </div>
           <div className="col-md-4 mt-3">
         <div className="address-cards">
  <div className="address-card">
    <h3>ELITE MEDICAL CARE</h3>
    <h4>Krishnanagar Address</h4>
    <p className='mb-1'>Talpukur Road, Krishnagar, Nadia 741101</p>

    <a href="tel:+919732775201">+91 9732775201</a>
  
  </div>

  <div className="address-card">
    <h3>ELITE MEDICAL CARE</h3>
    <h4>Ranaghat Address</h4>
    <p className='mb-1'>Rajbagan Para, Ranaghat, West Bengal 741201</p>

    <a href="tel:+919242408330">+91 9242408330</a>
  </div>
</div>
        </div>
        </div>
        </div>
      </div>
      <div className="album py-3">
        <div className="container">
          <center>
            <h1 className='mb-0'><b><b style={{ color: "#CC000A" }}>Elite Medical Care</b> – Advanced Care, Trusted Doctors</b></h1>
            <p><small>Elite Medical Care provides trusted healthcare services with expert doctors, advanced diagnostics, and compassionate treatment – ensuring your health is always our top priority.</small></p>
          </center>
        </div>

      </div>
      <div className="album py-0">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="d-flex justify-content-start align-items-center mb-2">
                <div className="col-md-6 me-2 mt-3">
                  <a href='find-doctor'>
                    <div className="card" >
                      <img src={Doctorbook} className="card-img-top" alt="Doctor Chamber Krishnagar" />
                      <div className="card-body">
                        <h5 className="card-title mb-1">Find a Doctor</h5>
                        <p className="card-text"><small>সহজেই ডাক্তার খুঁজে নিন ও অ্যাপয়েন্টমেন্ট বুক করুন</small></p>
                        <a href="find-doctor" className="learnmore">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                          <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                        </svg></a>
                      </div>
                    </div>
                  </a>
                </div>
                <div className="col-md-6 mt-3">
                  <a href='labtest'>
                    <div className="card" >
                      <img src={Labtestbook} className="card-img-top" alt="Labtest Book Krishnahgar"/>
                      <div className="card-body">
                        <h5 className="card-title mb-1">Lab Test Book</h5>
                        <p className="card-text"><small>সঠিক রিপোর্ট ও নির্ভরযোগ্য সেবা—এখন ঘরে বসেই বুক করুন</small></p>
                        <a href="labtest" className="learnmore">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                          <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                        </svg></a>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="d-flex justify-content-start align-items-center mb-2">
                <div className="col-md-6  me-2 mt-3">
                  <a href='healthpackage'>
                    <div className="card" >
                      <img src={healthpackage} className="card-img-top" alt="healthpackage" />
                      <div className="card-body">
                        <h5 className="card-title mb-1">Health Package</h5>
                        <p className="card-text">Trusted diagnostics with fast reports.</p>
                        <a href="healthpackage" className="learnmore">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                          <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                        </svg></a>
                      </div>
                    </div>
                  </a>
                </div>

                <div className="col-md-6 mt-3">
                  <div className="card" >
                    <a href='Radiology'>
                      <img src={radiology} className="card-img-top" alt="radiology" />
                      <div className="card-body">
                        <h5 style={{color:"black"}} className="card-title mb-1">Radiology</h5>
                        <p style={{color:"black"}} className="card-text">Trusted diagnostics with fast reports.</p>
                        <a href="Radiology" className="learnmore">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                          <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                        </svg></a>
                      </div>
                      </a>
                  </div>
                </div>
              </div>

            </div>




          </div>
        </div>
      </div>
      <br />

      <AllDoctor />
      <br />
      <div className="album py-0">
        <div className="container">
          <center>

            <h1 className='mb-0'>Authorized Partner of Dr. Lal Path Labs in <b style={{ color: "#CC000A" }}>Krishnagar</b></h1>
            <p><small>We are the Authorized Collection Partner of Dr. Lal PathLabs in the Krishnagar region, committed to delivering accurate, reliable, and timely diagnostic services.</small></p>
          </center>
        </div>

      </div>

      <div className="album py-2">
        <div className="container">
          <div className="row">
            <div className="col-md-6 mt-3">
              <img src={drlalpathlab} className="d-block w-100" alt="drlalpathlabkrishnagar" />

            </div>
            <div className="col-md-6 mt-3">
              <img src={drlalpathlabpackage} className="d-block w-100" alt="drlalpathlabkrishnagar" />

            </div>
          </div>
        </div>
      </div>
      <Labtest />
      <br />
      <div className="album py-3">
        <div className="container">
          <center>
            <h1 className='mb-0'><b><b style={{ color: "#CC000A" }}>Elite Medical Care</b> Radiology</b></h1>
            <p><small>e prioritize your comfort, safety, and convenience at every step — from registration to reporting.</small></p>
          </center>
        </div>

      </div>
      <Radiology />

      <div className="album py-2">
        <div className="container">
          <div className="row">
            <div className="col-md-12 mt-3">
              <iframe src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fkrishnagarelitemedicalcare%2F&tabs=timeline&width=1000&height=500&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId" width="100%" height="500" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
            </div>
            {/* <div className="col-md-6 mt-3">
             <iframe src="https://www.facebook.com/plugins/video.php?height=476&href=https%3A%2F%2Fwww.facebook.com%2Fsiddheswari.bastralaya.2025%2Fvideos%2F1490364308624825%2F&show_text=true&width=267&t=0" width="100%" height="600"  scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share" allowFullScreen="true"></iframe>

            </div> */}
          </div>
        </div>
      </div>

    </div>
  )
}

export default Home